/* -------------------------------------------------------------------------- */
/* Filters MIXIN                                                                */
/* -------------------------------------------------------------------------- */
import {
    Component, Mixins,
} from 'vue-property-decorator';
import { numbers, NotValidDigit } from '@components/shared/utils/number';

/**
 * Forms Mixin
 */
@Component
class FiltersMixin extends Mixins() {
    /**
     * Converts English digits into asked locale formatted number
     * 
     * @param {string|number} digit
     * @param {string} locale
     * @returns {string|number}
     */
    digits = (digit: string | number, locale: string = 'en'): string | number => {
        if (NotValidDigit(digit)) {
            return digit;
        }
        return `${digit}`.replace(/[0123456789]/g, (w) => numbers[locale][numbers.en.indexOf(w)]).replace(/[۰۱۲۳۴۵۶۷۸۹]/g, (w) => numbers[locale][numbers.fa.indexOf(w)]).replace(/[٠١٢٣٤٥٦٧٨٩]/g, (w) => numbers[locale][numbers.ar.indexOf(w)]);
    }
}

export default FiltersMixin;
